export default {
  methods: {
    copyToClipboard(text) {
      navigator.clipboard.writeText(text);
    }
  }
}
